function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M856.8 853.3c-189.7.1-522.5 1.6-712.7 2.8C64.6 856.6 0 790.3 0 708.3V202.1l100 85.3L472 607c7.2 8 17.4 12.5 28.1 12.5s20.8-4.5 28.1-12.5L986 213.6l14-11.1v503.1c0 81.5-64 147.7-143.2 147.7",
    style: {
      fill: "#63849f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m947.1 143.9-447 384L53 143.9z",
    style: {
      fill: "#76b5e4"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export default ForwardRef;